import {
  amplitudeSendEvent,
  amplitudeSendScreenEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { getScreenNameWithFallback } from '../../common/utils/getScreenNameWithFallback';

const SCREEN_MY_COUPON = 'screen_curator_shop_my_coupon';
const SCREEN_COUPON_VISIT = 'screen_curator_shop_coupon_visit';

export function trackShopCouponScreenViewMusinsa(params: { curatorId: string }): void {
  amplitudeSendScreenEvent({
    action_name: 'screen',
    event_name: 'screen_curator_shop_coupon_visit',
    note: 'curator_shop_coupon_visit',
    from: getScreenName(),
    id: params.curatorId,
  });
}

export function trackMyShopCouponScreenViewMusinsa(params: { curatorId: string }): void {
  amplitudeSendScreenEvent({
    action_name: 'screen',
    note: 'curator_shop_my_coupon',
    event_name: 'screen_curator_shop_my_coupon',
    from: getScreenName(),
    id: params.curatorId,
  });
}

export function trackCouponDownloadClickMusinsa(params: {
  type: string;
  brandId: string;
  couponName: string;
  curatorId: string;
}): void {
  amplitudeSendEvent({
    action_name: 'click',
    brand_id: params.brandId,
    button_name: 'coupon_download',
    component_name: 'button',
    coupon_name: params.couponName,
    event_name: 'click_button',
    from: getScreenName(),
    id: params.curatorId,
    name: '쿠폰 받기',
    section_name: 'curator_collaboration',
    type: params.type,
  });

  pushDataLayer('click_content', {
    brand_id: params.brandId,
    content_id: params.curatorId,
    content_name: params.couponName,
    content_type: params.type,
    index: GTM_NOTSET_STRING,
    section_index: '3',
    section_name: 'curator_collaboration',
  });
}

export function trackAllCouponDownloadClickMusinsa(params: { curatorId: string }): void {
  amplitudeSendEvent({
    action_name: 'click',
    button_name: 'coupon_download_all',
    component_name: 'button',
    event_name: 'click_button',
    from: getScreenName(),
    id: params.curatorId,
    name: '쿠폰 전체 받기',
  });

  pushDataLayer('click_content', {
    content_id: params.curatorId,
    content_name: '쿠폰 전체 받기',
    index: GTM_NOTSET_STRING,
    section_name: 'curator_collaboration',
    section_index: '4',
  });
}

// NOTE: Phase2 신규 - 큐레이터 쿠폰함(본인) 링크 복사. AMP id/button_name 정규화 +
// GA4(2605 시트 row 3) click_content. spec 의 V 컬럼은 `extra_info` 이지만 셀 정렬상
// button_name 으로 해석 (button_id/_name 자리는 공란).
export function trackMyShopCouponCopyLinkClickMusinsa(params: {
  brandId: string;
  couponId: number;
  couponName: string;
  curatorId: string;
}): void {
  amplitudeSendEvent({
    action_name: 'click',
    brand_id: params.brandId,
    button_name: 'copy_link',
    component_name: 'button',
    coupon_name: params.couponName,
    event_name: 'click_button',
    from: getScreenNameWithFallback(SCREEN_MY_COUPON),
    id: params.curatorId,
    name: '링크 복사',
    section_name: 'curator_collaboration',
  });

  pushDataLayer('click_content', {
    brand_id: params.brandId,
    content_id: String(params.couponId),
    content_name: params.couponName,
    content_profile_id: params.curatorId,
    extra_info: 'copy_link',
    index: GTM_NOTSET_STRING,
    section_index: '3',
    section_name: 'curator_collaboration',
  });
}

// NOTE: Phase2 신규 - 큐레이터 쿠폰함(본인) 적용 상품 클릭. GA4 2605 시트 row 4.
export function trackMyShopCouponAppliedGoodsClickMusinsa(params: {
  brandId: string;
  couponId: number;
  couponName: string;
  curatorId: string;
}): void {
  amplitudeSendEvent({
    action_name: 'click',
    brand_id: params.brandId,
    button_name: 'applied_goods',
    component_name: 'button',
    coupon_name: params.couponName,
    event_name: 'click_button',
    from: getScreenNameWithFallback(SCREEN_MY_COUPON),
    id: params.curatorId,
    name: '적용 상품',
    section_name: 'curator_collaboration',
  });

  pushDataLayer('click_content', {
    brand_id: params.brandId,
    content_id: String(params.couponId),
    content_name: params.couponName,
    content_profile_id: params.curatorId,
    extra_info: 'applied_goods',
    index: GTM_NOTSET_STRING,
    section_index: '4',
    section_name: 'curator_collaboration',
  });
}

// NOTE: Phase2 신규 - 큐레이터 쿠폰함(방문) 적용 상품 클릭. GA4 2605 방문 시트 row 6.
// 방문 시트에는 content_type({{쿠폰할인율}})까지 포함.
export function trackShopCouponAppliedGoodsClickMusinsa(params: {
  brandId: string;
  couponId: number;
  couponName: string;
  couponType: string;
  curatorId: string;
}): void {
  amplitudeSendEvent({
    action_name: 'click',
    brand_id: params.brandId,
    button_name: 'applied_goods',
    component_name: 'button',
    coupon_name: params.couponName,
    event_name: 'click_button',
    from: getScreenNameWithFallback(SCREEN_COUPON_VISIT),
    id: params.curatorId,
    name: '적용 상품',
    section_name: 'curator_collaboration',
  });

  pushDataLayer('click_content', {
    brand_id: params.brandId,
    content_id: String(params.couponId),
    content_name: params.couponName,
    content_profile_id: params.curatorId,
    content_type: params.couponType,
    extra_info: 'applied_goods',
    index: GTM_NOTSET_STRING,
    section_index: '5',
    section_name: 'curator_collaboration',
  });
}
